var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.625C10.3321 10.625 10.5 10.7929 10.5 11V15.5C10.5 15.7071 10.3321 15.875 10.125 15.875C9.91789 15.875 9.75 15.7071 9.75 15.5V11C9.75 10.7929 9.91789 10.625 10.125 10.625Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.625C12.2071 10.625 12.375 10.7929 12.375 11V15.5C12.375 15.7071 12.2071 15.875 12 15.875C11.7929 15.875 11.625 15.7071 11.625 15.5V11C11.625 10.7929 11.7929 10.625 12 10.625Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11C14.25 10.7929 14.0821 10.625 13.875 10.625C13.6679 10.625 13.5 10.7929 13.5 11V15.5C13.5 15.7071 13.6679 15.875 13.875 15.875C14.0821 15.875 14.25 15.7071 14.25 15.5V11Z",
    fill: "#585858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.75C16.875 9.16421 16.5392 9.5 16.125 9.5H15.75V16.25C15.75 17.0784 15.0784 17.75 14.25 17.75H9.75C8.92157 17.75 8.25 17.0784 8.25 16.25V9.5H7.875C7.46079 9.5 7.125 9.16421 7.125 8.75V8C7.125 7.58579 7.46079 7.25 7.875 7.25H10.5C10.5 6.83579 10.8358 6.5 11.25 6.5H12.75C13.1642 6.5 13.5 6.83579 13.5 7.25H16.125C16.5392 7.25 16.875 7.58579 16.875 8V8.75ZM9.08853 9.5L9 9.54426V16.25C9 16.6642 9.33579 17 9.75 17H14.25C14.6642 17 15 16.6642 15 16.25V9.54426L14.9115 9.5H9.08853ZM7.875 8.75H16.125V8H7.875V8.75Z",
    fill: "#585858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.625C10.3321 10.625 10.5 10.7929 10.5 11V15.5C10.5 15.7071 10.3321 15.875 10.125 15.875C9.91789 15.875 9.75 15.7071 9.75 15.5V11C9.75 10.7929 9.91789 10.625 10.125 10.625Z",
    fill: "#585858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.625C12.2071 10.625 12.375 10.7929 12.375 11V15.5C12.375 15.7071 12.2071 15.875 12 15.875C11.7929 15.875 11.625 15.7071 11.625 15.5V11C11.625 10.7929 11.7929 10.625 12 10.625Z",
    fill: "#585858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11C14.25 10.7929 14.0821 10.625 13.875 10.625C13.6679 10.625 13.5 10.7929 13.5 11V15.5C13.5 15.7071 13.6679 15.875 13.875 15.875C14.0821 15.875 14.25 15.7071 14.25 15.5V11Z",
    fill: "#585858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 8.75C16.875 9.16421 16.5392 9.5 16.125 9.5H15.75V16.25C15.75 17.0784 15.0784 17.75 14.25 17.75H9.75C8.92157 17.75 8.25 17.0784 8.25 16.25V9.5H7.875C7.46079 9.5 7.125 9.16421 7.125 8.75V8C7.125 7.58579 7.46079 7.25 7.875 7.25H10.5C10.5 6.83579 10.8358 6.5 11.25 6.5H12.75C13.1642 6.5 13.5 6.83579 13.5 7.25H16.125C16.5392 7.25 16.875 7.58579 16.875 8V8.75ZM9.08853 9.5L9 9.54426V16.25C9 16.6642 9.33579 17 9.75 17H14.25C14.6642 17 15 16.6642 15 16.25V9.54426L14.9115 9.5H9.08853ZM7.875 8.75H16.125V8H7.875V8.75Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeDeleteIcon);
export default __webpack_public_path__ + "static/media/loree-deleteIcon.d6402f7b1f9d864cac8b8b8bf7f33759.svg";
export { ForwardRef as ReactComponent };